import AVdxbUploadField from './index.vue';

AVdxbUploadField.install = app => {
  app.component(AVdxbUploadField.name, AVdxbUploadField);
};

export default AVdxbUploadField;
